module.exports = __webpack_public_path__ + "img/Guirlande_guinguette.b410821.jpg";